import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from "../../../../../../../shared/snackbar/snackbar-slice";
import { doc, getDoc, updateDoc } from "@firebase/firestore";
import { addItemPhotos } from "../item-photos-list/item-photos-list-slice";
import { getItemData, hideLoading, showLoading } from "./item-photos-add-slice";
import { editItems } from "../../../../items-list-slice";

export const getItemsDataService = async (dispatch, db, coll, id) => {
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const formData = docSnap.data();
            dispatch(getItemData(formData));
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when fetching the data.'));
        console.error("ItemPhotosAdd getItemsDataService error: ", e);
    }
};

const uploadPhoto = async (dispatch, storageRef, file) => {
    try {
        const uploadTask = uploadBytesResumable(storageRef, file);
        const snapshot = await uploadTask;
        const downloadURL = await getDownloadURL(snapshot.ref);
        dispatch(showSuccessSnackbar("Photo uploaded successfully!"));
        return downloadURL;
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when uploading the photo.'));
        console.error("ItemPhotosAdd uploadPhoto error: ", e);
    }
};

const updateItem = async (dispatch, db, coll, id, formData, uploadURL) => {
    try {
        const new_data = {
            ...formData,
            image_url: [...(formData.image_url || []), uploadURL],
        };
        await updateDoc(doc(db, coll, id), new_data);
        // Wait for the document to be updated
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(editItems(data));
        dispatch(addItemPhotos(uploadURL));
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when updating the item.'));
        console.error("ItemPhotosAdd updateItem error: ", e);
    }
};

export const addPhotosService = async (dispatch, db, coll, id, formData, storageRef, file) => {
    dispatch(showLoading());
    try {
        if (file) {
            const uploadURL = await uploadPhoto(dispatch, storageRef, file);
            await updateItem(dispatch, db, coll, id, formData, uploadURL);
        } else {
            dispatch(showWarningSnackbar("File does not exist."));
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'));
        console.error("ItemPhotosAdd addPhotosService error: ", e);
    }
    dispatch(hideLoading());
};